module.exports = __webpack_public_path__ + "img/part4-icon2.928a9a03.png";